import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const SvgChart = styled.svg`
  position: absolute;
  width: 100%;
  height: 100%;
  max-height: 300px;
  top: 0;
  left: 0;
`;

export const RectBackground = styled.rect`
  // Fix: Firefox min-blend-mode issue. The background color has to be dark:
  // https://app.clickup.com/t/8693t8dmd
  fill: var(--background-default);
`;

export const PathPlot = styled.path`
  stroke-width: 2;
  fill: none;
  stroke: var(--surface-white);
`;

export const LineXAxis = styled.line`
  stroke: var(--border-soft);
  stroke-width: 1;
`;

export const AxisText = styled.text`
  ${typographyV2.bodySm};
  fill: var(--text-soft);
  font-family: var(--font-roboto-mono);
`;

export const ThresholdAxis = styled.g`
  width: 50px;
`;
